var VideoManager = {
	'playerCount': 0
};

function vplayer(disablectl) {
	this.state = "";
	this.tabgroup = "hotspots";
	this.loop = false;
	this.firstClick = false;

	TPL.lng("tips.volume", 'Głośność')
	this.l = {
		'btn.play': TPL.lng("tips.vplayer.play", 'Uruchom odtwarzanie'),
		'btn.pause': TPL.lng("tips.vplayer.stop", 'Zatrzymaj odtwarzanie'),
		'btn.resume': TPL.lng("tips.vplayer.resume", 'Wznów odtwarzanie'),
	};

	VideoManager.playerCount ++;

	this.$vnode = $("<video width='100%' height='100%'></video>");
	this.vnode = this.$vnode[0];

	this.$node = $("<div class='video-player'><div class='video-screen'></div><div class='video-controls'></div></div>");
	this.$videoscreen = this.$node.find(".video-screen");
	this.$videoctl = this.$node.find(".video-controls");

//	this.node.css('height', '100%');
//	this.$videoscreen.css('height', 'calc(100% - 60px)');

	this.$screenctl = $("<a href='javascript:void(null);' class='screen-ctl paused' title='" + this.l['btn.play'] + "'><div class='ctl'><span class='fa fa-play'></span></div></a>");

	this.$videoscreen.append(this.$vnode);
	this.$videoscreen.append(this.$screenctl);

	this.$play = $("<a href='javascript:void(null);' class='play-button speaks' data-speakgroup='TIPS' data-speak='HTML5.tips.vplayer.play' title='" + this.l['btn.play'] + "'><span class='fa fa-play'></span></a>");
	this.$timeline = $("<div class='timeline'><div class='progress'></div></div>");
	this.$progress = this.$timeline.find(".progress");
	this.$time = $("<div class='time'></div>");

	this.$navbuttons = $("<div class='nav-buttons'></div>");
	this.$navbar = $("<div class='nav-bar'></div>");

	this.$navbuttons.append(this.$play);
	this.$navbar.append(this.$time);
	this.$navbar.append(this.$timeline);

	this.$videoctl.append(this.$navbuttons);
	this.$videoctl.append(this.$navbar);

	var self = this;

	if (disablectl) {
		this.$node.css("pointer-events", "none");
		this.$videoctl.css("pointer-events", "none");
		this.$navbar.css("pointer-events", "none");
		this.$navbuttons.css("pointer-events", "none");
		this.$play.css("pointer-events", "none");
		this.$progress.css("pointer-events", "none");
		this.$timeline.css("pointer-events", "none");
		this.$time.css("pointer-events", "none");
		this.$videoscreen.css("pointer-events", "none");
		this.$screenctl.css("pointer-events", "none");
		this.$vnode.css("pointer-events", "none");
	}

	if (disablectl == undefined) {
		this.$play.on("click", function(evt) {self.playButton(evt);});
		this.$screenctl.on("click", function(evt) {self.playButton(evt);});
	}

	this.title = "";

	this.setTitle = function(t) {
		if (this.title != "" && t == "" && this.$title != undefined) {
			this.$title.delete();
			this.$title = undefined;
		}
		this.title = t;

		if (this.title != "") {
			if (this.$title == undefined) {
				this.$title = $("<div class='title'>" + this.title + "</div>");
				this.$node.append(this.$title);
			} else {
				this.$title.html(this.title);
			}
		}
	}

	this.showControls = function(s) {
		if (s == false) this.$node.find(".video-controls").hide();
		else this.$node.find(".video-controls").show();
	}

	this.style = function(selector, style) {
		if (selector != "")
			this.$node.find(selector).css(style);
		else
			this.$node.css(style);
	}

	this.setLoop = function(s) {
		this.loop = s;
	}

	this.embed = function() {
		return this.$node;
	}

	this.load = function(src) {
		this.src = src;

		this.vnode.src = src;

		var self = this;

		this.vnode.addEventListener("loadedmetadata", function (e) {
    		self.vwidth = this.videoWidth;
        	self.vheight = this.videoHeight;
			self.updateTime();
			self.fit();
		}, false );

		this.vnode.addEventListener("timeupdate", function(e) {
			var progress = self.vnode.currentTime / self.vnode.duration;
			self.$progress.css("width", (progress * 100) + "%");
			self.updateTime();
			if (progress == 1 && self.loop) {
				self.vnode.currentTime = 0;
				self.vnode.play();
			}
		});

		this.vnode.addEventListener("pause", function(e) {
			self.state = "paused";
			self.updatePlayButtonState()
		});

		this.vnode.addEventListener("play", function(e) {
			self.$vnode.css("opacity", "1");
			self.state = "playing";
			self.updatePlayButtonState()
		});

		Tab.add(this.tabgroup, Tab.simpleTab(this.$play, 0), {});
	}

	this.playButton = function(evt) {
		if (this.state == "")
			this.vnode.play();
		else if (this.state == "playing")
			this.vnode.pause();
		else if (this.state == "paused")
			this.vnode.play();
	}

	this.stop = function() {
		this.vnode.pause();
	}

	this.play = function() {
		this.vnode.play();
	}

	this.toggle = function() {
		if (this.state == "")
			this.vnode.play();
		else if (this.state == "playing")
			this.vnode.pause();
		else if (this.state == "paused")
			this.vnode.play();
	}

	this.toggleUI = function(b) {
		if (b) {
			this.$node.removeClass("hidden");
//			this.$videoctl.css("visibility", "visible");
//			this.$screenctl.css("visibility", "visible");
			this.$videoctl.show();
			this.$screenctl.show();
		} else {
			this.$node.addClass("hidden");
			//this.$videoctl.css("visibility", "hidden");
			//this.$screenctl.css("visibility", "hidden");
			this.$videoctl.hide();
			this.$screenctl.hide();
		}
	}

	this.autostart = function(b, isMuted) {
		if (!b) return;

		this.astart = b;

		try {
			if (isMuted == undefined) this.vnode.muted = true;
			else this.vnode.muted = isMuted;
			this.play();

		} catch(e) {
			if (b) {
				setTimeout(function() { this.autostart(this.astart); }.bind(this), 100);
			}
		}
	}

	this.updatePlayButtonState = function() {
		switch(this.state) {
			case "playing":
				this.$play.html("<span class='fa fa-pause'></span>");
				this.$play.attr("title", this.l['btn.pause']);
				this.$play.attr("data-speak", "HTML5.tips.vplayer.stop");

				this.$screenctl.find('.ctl').html("<span class='fa fa-pause'></span>");
				this.$screenctl.removeClass('paused');
				this.$screenctl.attr("title", this.l['btn.pause']);
			break;

			case "paused":
				this.$play.html("<span class='fa fa-play'></span>");
				this.$play.attr("title", this.l['btn.resume']);
				this.$play.attr("data-speak", "HTML5.tips.vplayer.resume");

				this.$screenctl.find('.ctl').html("<span class='fa fa-play'></span>");
				this.$screenctl.addClass('paused');
				this.$screenctl.attr("title", this.l['btn.resume']);
			break;
		}
	}

	this.readableTime = function(dt) {
		dt = Math.round(dt);
		var m = Math.floor(dt / 60);
		var s = dt % 60;

		if (m < 10) m = "0" + m;
		if (s < 10) s = "0" + s;

		return m + ":" + s;
	}

	this.updateTime = function() {
		this.$time.html(this.readableTime(this.vnode.currentTime) + " / " + this.readableTime(this.vnode.duration));
	}

	this.fitScreen = function(mw, mh ,force) {
		this.bbox = {"mw": mw, "mh": mh, "force": force};
	}

	this.setOpacity = function(pr) {
		if (pr == undefined) {
				this.$node.css("opacity", 1);
		} else {
			this.$node.css("opacity", pr * 0.01);
		}
	}

	this.setSize = function(w, h, u, keepaspect) {
		var ux = 0;
		var uy = 0;

		if (u == undefined || u == "px") {
			ux = "px";
			uy = "px";
		}

		if (u == "%") {
			ux = "vw";
			uy = "vh";
		}

		this.$node.css("width", w + ux);		
		if (keepaspect == undefined || keepaspect === false) this.$node.css("height", h + uy);		
	}

	this.setFullscreen = function(b) {
		if (b) {
			this.$node.addClass("fullscreen");
		} else {
			this.$node.removeClass("fullscreen");
		}
	}

	this.fit = function() {
		if (this.bbox != undefined) {

			if (this.bbox.force == 1) {
				var ratio = this.vwidth / this.vheight;

				if (this.bbox.mw > player._width) this.bbox.mw = player._width;
				if (this.bbox.mh > player._height) this.bbox.mh = player._height;

				pw = 0;
				ph = 0;

				if (this.bbox.mw / ratio > this.bbox.mh) {
					ph = this.bbox.mh;
					pw = (ph - 65) * ratio;
				} else {
					pw = this.box.mw;
					ph = this.box.mw / ratio;
				}

				this.$node.css("width", pw);
				this.$node.css("height", ph);
			} else {
				var ratio = this.vwidth / this.vheight;
				var bw = player._width - this.bbox.mw * 2;
				if (bw < 300) bw = player._width;

				var bh = player._height - this.bbox.mh * 2;
				if (bh < 200) bh = player_height;

				if (bw / ratio > bh) {
					this.$node.css("width", bh * ratio);
				} else {
					this.$node.css("width", bw);
				}
			}
		}
	}

	AppEvent.on(player, "VOLUME.SET", function() {
		if (Volume.currentYTVolume() > 0) self.vnode.volume = (Volume.currentYTVolume() * 0.01);
	});

	AppEvent.on(player, "SOUND.UNMUTED", function() {
		if (!Volume.yt.muted && !Volume.master.muted) self.vnode.muted = false;
	});
	AppEvent.on(player, "SOUND.MUTED", function() {
		if (Volume.yt.muted || Volume.master.muted) self.vnode.muted = true;
	});

	AppEvent.on(player, "FIRST.CLICK", function() {
		if (self.vnode.muted && self.astart) {
			self.vnode.muted = false;
			self.firstClick = true;
		}
	});

	this.$node.one('click', function() {
		if (!self.firstClick && self.vnode.muted && self.astart) {
			self.vnode.muted = false;
			self.firstClick = true;
		}
	});
}
